var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { CardItem } from "@/share/CardItem";
import { ObjectUpdateType } from "@/share/models";
import { ALLViewer, NoteStatus } from "@@/Annotation";
import { DateLib } from "@@/Datelib";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { SchemaItemType } from "@@/Schema";
import { AlignMent } from "@@/Tab";
import { isIpadScreen, stripHTML, timeout } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
import { ColorStore } from "@/app/UIComponents/ColorDialog";
import { CommentState } from "@/app/UIComponents/Comments";
import { FileUploadDialogState } from "@/app/UIComponents/FileUploadDialog";
import { SelectMemberDialogState } from "@/app/UIComponents/SelectMemberDialog";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { CalendarViewState } from "@/app/uistore/CalendarViewState";
import { ChartType, ChartViewState } from "@/app/uistore/ChartViewState";
import { DraftNoteUI } from "@/app/uistore/DraftNoteUI";
import { KanbanStore } from "@/app/uistore/KanbanStore";
import { NotesFilterState } from "@/app/uistore/NotesFilterState";
import { TimelineState } from "@/app/uistore/TimelineState";
import { FilterDialogState } from "@/app/UIComponents/FilterDialogState";
import { BaseDialogState } from "@/app/UIComponents/BaseDialog";
import { convertDepToRows, parser, decryptCell as GDecryptcell, canShowRemoteEntry } from "@@/RuleParser";
export class AdminSchemaStore {
    constructor() {
        this.schemas = new Map();
        this.sortedschemaitems = [];
        this.enableallsel = false;
        this.editrowslistitems = [];
        this.duplicating = false;
        this.duplicatingcount = 0;
        this.totalduplicatecount = 0;
        this.drows = [];
        this.deleteentries = [];
        this.activelterid = "";
        this.loading = false;
        this.activeschema = "";
        this.loadingcontent = false;
        this.showform = false;
        this.listitems = [];
        this.changedlistitems = new Set();
        this.storingform = false;
        this.updatingdatasheet = false;
        this.parsingentry = new Set();
        this.formentry = new Map();
        this.rowsMap = new Map();
        this.newrowsmap = [];
        this.buildingview = false;
        this.showlinkdialog = false;
        this.deleteingrows = false;
        this.showactiveviewmenu = false;
        this.activeview = "grid";
        this.copyactive = false;
        this.showdtmennu = false;
        this.copyschema = undefined;
        this.metadatadialog = new BaseDialogState();
        this.afx = 0;
        this.afy = 0;
        this.showfilter = false;
        this.commentstate = new CommentState();
        // public schemaimportstate = new ExcelImportDialogState.ExcelImportDialogState();
        this.selectedrows = new Map();
        this.showactions = false;
        this.chatstate = new CommentState();
        this.smstate = new SelectMemberDialogState();
        this.rowstate = new SelectMemberDialogState();
        this.schemamstate = new SelectMemberDialogState();
        this.activeusers = [];
        this.lastcommenttime = -1;
        this.lastchattime = -1;
        this.tableref = null;
        this.showstatuesmenu = false;
        this.buildingrulefor = new Map();
        this.buildingruleforscol = new Set();
        this.loadmore = false;
        this.activecardsttaus = "";
        this.activecardgroupby = "";
        this.hiddenrows = new Set();
        this.activecardstatusname = "";
        this.activecardgroupname = "";
        this.startnotes = false;
        this.showgroupbymenu = false;
        this.showganttstartdate = false;
        this.showganttstartdatename = "Task Start Date";
        this.showganttenddatename = "Task End Date";
        this.colorfieldname = "Default Colors";
        this.colorfieldid = "";
        this.showcolorfield = false;
        this.showchartmenu = false;
        this.showcolumnview = false;
        this.links = [];
        this.schemanotesloading = false;
        this.checkingandcollecting = false;
        this.rowRules = new Map();
        this.accessstorestate = new AccessGroupState();
        this.storeschemaids = new Set();
        this.activeschemametaids = new Set();
        this.colwithschemarules = new Set();
        // public rulebuilderstate: RuleBuilderStore = new RuleBuilderStore();
        // public rowrulebuilderstate: RuleBuilderStore = new RuleBuilderStore();
        this.gettinganas = false;
        this.anas = new Map();
        this.anasschema = new Map();
        this.activeloadednotesref = "";
        this.deletenoteids = new Set();
        this.shownotespanel = !isIpadScreen() ? true : false;
        this.descfieldname = "";
        this.descfieldid = "";
        this.showdescfield = false;
        this.activedetailtab = "detail";
        this.loadingcomments = false;
        this.loadingchats = false;
        this.deletingnote = false;
        this.enableannotation = true;
        this.readonlyrows = false;
        this.showrowsilter = false;
        this.savingschema = false;
        this.filterdialogstate = new FilterDialogState();
        this.schemasmap = new Map();
        this.selectallrows = false;
        this.colorstate = new ColorStore();
        this.lastnotesupdatetime = -1;
        this.notesbyid = new Map();
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = "---";
        this.editnoteid = "";
        this.activeentriesid = "";
        this.editmode = false;
        this.showcomments = false;
        this.loadingnotes = false;
        this.authors = new Map();
        this.showdervivedschemafields = false;
        this.activerequestid = "";
        this.notefilterstate = new NotesFilterState();
        this.hiddencolumns = new Set();
        this.showganttenddate = false;
        this.ganttstartid = "";
        this.ganttendid = "";
        this.ganttasknameid = "";
        this.ganttasknamefieldname = "";
        this.activerowid = "";
        this.savingrow = false;
        this.savingnote = false;
        this.addingrowtochild = false;
        this.activechildschema = "";
        this.editrowproperty = new Map();
        this.activerowindex = -1;
        this.notelinksdialogleft = 0;
        this.notelinksdialogtop = 70;
        this.chartstate = new Map();
        this.colors = ['#fec1ce', '#d7f3f2', '#cbd8f9'];
        this.removingrowsfromsh = new Set();
        this.showpasswordfor = new Set();
        this.activebuilingid = -1;
        this.kanbanstatus = new KanbanStore();
        this.timelinestatus = new TimelineState();
        this.calendarstate = new CalendarViewState();
        this.showinoutlinks = new Set();
        this.activeaction = "unknown";
        this.depschemarows = new Map();
        this.depschema = new Map();
        this.fetchingdepend = false;
        this.waitingentries = [];
        this.activedatasheet = "";
        this.fileuploadstate = new FileUploadDialogState();
        this.activereqid = "";
        this.initdatasheetid = "";
        this.initischemaid = "";
        this.initrowid = "";
        this.deletingschema = false;
        this.deletingschid = "";
        this.vfx = 0;
        this.vfy = 0;
        this.cfx = 0;
        this.cfy = 0;
        this.chartfx = 0;
        this.chartfy = 0;
        this.sfx = 0;
        this.sfy = 0;
        this.fieldfx = 0;
        this.fieldfy = 0;
        this.gfx = 0;
        this.gfy = 0;
        this.activeuserid = "";
        this.dependentdata = new Map();
        this.rowsarrids = [];
        this.loadedentry = 0;
        makeObservable(this);
        APPEvent.addSubscriberForAdminGetDatasheet((schs) => {
            if (this.initdatasheetid) {
                for (const sh of schs) {
                    if (sh.id === this.initdatasheetid) {
                        this.setActiveDatasheet(this.initdatasheetid);
                        break;
                    }
                }
                this.initdatasheetid = "";
            }
        });
        APPEvent.addSubscriberForUpdateDatasheet((sh) => {
            this.setUpdatingDatasheet(false);
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForUpdateEntry((data) => {
            var _a;
            if (data.sid === this.activeschema && data.row !== undefined) {
                this.updateRow((_a = data.rowid) !== null && _a !== void 0 ? _a : '', data.row.entry);
                this.setSavingRow(false);
            }
        });
        APPEvent.addSubscriberForAdminGetNote((notes) => {
            if (notes.letrid === this.activelterid && notes.objectid.indexOf("datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) !== -1) {
                notes.note.forEach((n) => {
                    if (n.status === NoteStatus.Dead) {
                        this.removeNote(n.id);
                    }
                    else {
                        this.setAuthor(n);
                        this.addNote(n);
                    }
                });
                this.setLoadingNotes(false);
            }
        });
        APPEvent.addSubscriberForAdminForGetRows((rows) => {
            // lets now sort and add these rows!!
            if (rows.floating || rows.schemaid !== this.activeschema || rows.userid !== this.activeuserid) {
                return;
            }
            // if (this.loadingcontent) {
            //     this.addRows(rows.rows);
            //     if(this.initrowid && this.rowsMap.has(this.initrowid)) {
            //         this.setActiveRowId(this.initrowid);
            //     }
            //     this.initrowid = "";
            //     this.setLoadingContent(false);
            // }
            if (this.loadingcontent) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRowRule(rr);
                    }
                }
                // if (rows.deps) {
                //     this.decryptAndSetupDepRemoteItems(rows.deps);
                // }
                this.addRows(rows.rows);
                this.addRuleEntryToRows();
                if (this.initrowid && this.rowsMap.has(this.initrowid)) {
                    this.setActiveRowId(this.initrowid);
                }
                this.initrowid = "";
                // we have new rules now
                this.collectRowsAndBuildRulesResult();
                this.setLoadingContent(false);
            }
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            if (this.activelterid !== letr.id) {
                this.activelterid = letr.id;
                this.reset();
            }
        });
        APPEvent.addSubscriberForAdminGetSchema((schs) => {
            if (schs.floating) {
                return;
            }
            let set = "";
            for (const sch of schs.schema) {
                if (sch.letrid === this.activelterid) {
                    this.addSchema(sch);
                    if (this.activeschema === sch.id ||
                        this.initischemaid === sch.id) {
                        set = sch.id;
                    }
                }
            }
            if (!set) {
                set = Array.from(this.schemas.values()).sort((sh1, sh2) => sh1.name.toLowerCase().localeCompare(sh2.name.toLowerCase()))[0].id;
                this.initrowid = "";
            }
            if (set) {
                this.setActiveSchema(set);
            }
            this.initischemaid = "";
            this.setLoading(false);
        });
        APPEvent.addSubscriberForNoteUpdate((up) => {
            if (up.letrid === this.activelterid && up.objectid === "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
                /// we good to go here now!!
                let lastupdatetime = -1;
                for (const n of up.notes) {
                    if (n.status !== NoteStatus.Dead) {
                        this.addNote(n);
                    }
                    else {
                        // delete this note that's all!
                        this.removeNote(n.id);
                    }
                    if (n.updatetime > lastupdatetime) {
                        lastupdatetime = n.updatetime;
                    }
                }
                if (lastupdatetime > -1) {
                    this.lastnotesupdatetime = lastupdatetime;
                }
                else {
                    this.lastnotesupdatetime = new Date().getTime();
                }
            }
        });
        APPEvent.addSubscriberForGetComments((res) => {
            if (res.noteid === this.editnoteid) {
                // lets just add these now
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.commentstate.removeComment(com.id);
                    }
                    else {
                        this.commentstate.setComment(com);
                    }
                    if (com.updatetime > this.lastcommenttime) {
                        this.lastcommenttime = com.updatetime;
                    }
                });
                this.setLoadingComments(false);
            }
            else if (res.noteid === "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.chatstate.removeComment(com.id);
                    }
                    else {
                        this.chatstate.setComment(com);
                    }
                    if (com.updatetime > this.lastchattime) {
                        this.lastchattime = com.updatetime;
                    }
                });
                this.setLoadingChat(false);
                this.chattimeout = setTimeout(() => this.getChatUpdate(), 10000);
            }
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminDependResp(async (res) => {
            var _a;
            if (!res.floating && res.schemaid === this.activeschema && res.userid === this.activeuserid) {
                // awesome!!
                // lets store this now
                this.schemadep = res;
                // lets build data for columns now!!
                const mapofdata = new Map();
                if (res.depn) {
                    for (const en of res.depn) {
                        if (!mapofdata.has(en.id)) {
                            mapofdata.set(en.id, []);
                        }
                        (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(...en.entries);
                    }
                }
                // we should create some missing columns that we might need!!
                // there might be rule 
                this.depschemarows = convertDepToRows(mapofdata);
                if (res.schemas) {
                    for (const shh of res.schemas) {
                        this.schemasmap.set(shh.id, shh);
                    }
                }
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
                this.setFeatchingDepende(false);
                for (const en of this.waitingentries) {
                    // lets do these first and then we will be fine!
                    this.parseCellRule(en);
                }
                this.waitingentries = [];
                // also build the rule for one that are done!!
            }
        });
        APPEvent.addSubscriberForAdminPartialRows(async (rows) => {
            var _a;
            if (rows.floating || rows.schemaid !== this.activeschema || rows.userid !== this.activeuserid) {
                return;
            }
            if (rows.rows.length > 0) {
                await this.addRowInline(rows.rows, false);
                //await this.addToTemp(rows.rows);
                this.setLoadedRows(this.rowsMap.size);
            }
            if (rows.islast) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRowRule(rr);
                    }
                }
                if (rows.deps) {
                    this.decryptAndSetupDepRemoteItems(rows.deps, (_a = rows.depsdep) !== null && _a !== void 0 ? _a : []);
                }
                await this.addRuleEntryToRows();
                if (this.initrowid && this.rowsMap.has(this.initrowid)) {
                    this.setActiveRowId(this.initrowid);
                }
                if (this.initactivedetailtab !== undefined) {
                    this.setActiveTab(this.initactivedetailtab);
                }
                this.initrowid = "";
                // we have new rules now
                this.collectRowsAndBuildRulesResult();
                this.initactivedetailtab = undefined;
                await this.buildRowsArray();
                this.setLoadingContent(false);
            }
        });
    }
    async buildRowsArray() {
        const arr = [];
        let i = 0;
        for (const row of this.rowsMap) {
            arr.push(row[1]);
            if (i > 0 && i % 5000 == 0)
                await timeout(50);
            i++;
        }
        this.rowsarrids = arr;
        await timeout(50);
    }
    decryptAndSetupDepRemoteItems(dep, darr) {
        var _a;
        const sh = this.schemas.get(this.activeschema);
        if (!sh)
            return;
        const mapofdpsh = new Map();
        dep.data.forEach((dt) => {
            mapofdpsh.set(dt.schema.id, dt);
        });
        const mapofdata = new Map();
        const mapofschema = new Map();
        let doneenid = new Set();
        dep.data.forEach((dt) => {
            var _a;
            if (dt.schemaopen) {
                mapofschema.set(dt.schema.id, dt.schemaopen);
            }
            for (const en of dt.entries) {
                if (!doneenid.has(en.id)) {
                    if (!mapofdata.has(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) {
                        mapofdata.set(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid, []);
                    }
                    (_a = mapofdata.get(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
                    doneenid.add(en.id);
                }
            }
        });
        for (const en of darr) {
            if (!mapofdata.has(en.id)) {
                mapofdata.set(en.id, []);
            }
            for (const e of en.entries) {
                if (!doneenid.has(e.id)) {
                    (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(e);
                    doneenid.add(e.id);
                }
            }
        }
        // we should create some missing columns that we might need!!
        // there might be rule 
        const depschemarows = convertDepToRows(mapofdata);
        let ritems = [];
        for (const it of sh.items) {
            if (it.type === SchemaItemType.Remote) {
                ritems.push(it);
            }
            else if (it.type === SchemaItemType.List) {
                const lit = it;
                if (lit.items) {
                    for (const li of lit.items) {
                        if (li.item.type === SchemaItemType.Remote) {
                            ritems.push(li.item);
                        }
                    }
                }
            }
        }
        ritems.forEach((it) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (it.type === SchemaItemType.Remote) {
                const srit = it;
                if (srit.did && srit.sid && srit.cid) {
                    const dp = mapofdpsh.get(srit.sid);
                    if (dp !== undefined && dp.schemaopen !== undefined) {
                        const items = (_a = dp.schemaopen.items) !== null && _a !== void 0 ? _a : [];
                        let ischoice = false;
                        for (const item of items) {
                            if (item.id === srit.cid) {
                                // found it 
                                if (item.type === SchemaItemType.Choice) {
                                    // ohh all we need here is choice
                                    ischoice = true;
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    item.items.forEach((it) => {
                                        var _a;
                                        return (_a = this.dependentdata.get(id)) === null || _a === void 0 ? void 0 : _a.push({
                                            id: it.id,
                                            value: it.name
                                        });
                                    });
                                }
                                else {
                                    // not an choice 
                                    // we need to check conditions and parse the rules here!
                                    const enmap = new Map();
                                    for (const en of dp.entries) {
                                        if (!enmap.has(en.cellid)) {
                                            enmap.set(en.cellid, []);
                                        }
                                        (_b = enmap.get(en.cellid)) === null || _b === void 0 ? void 0 : _b.push(en);
                                    }
                                    if (srit.conds && srit.conds.length > 0) {
                                        // lets chekc if any rules apply to my entries we can open them up!
                                        for (const con of srit.conds) {
                                            for (const cp of con.params) {
                                                // now we have this 
                                                if (cp.leftcond) {
                                                    const ens = enmap.get(cp.leftcond);
                                                    if (ens) {
                                                        for (const e of ens) {
                                                            if (e.ruleopen) {
                                                                parser([e], dp.schemaopen, depschemarows, mapofschema);
                                                            }
                                                            else if (!e.decrypted) {
                                                                GDecryptcell(e, dp.schemaopen);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    const entries = dp.entries;
                                    for (const en of entries) {
                                        if (!en.decrypted) {
                                            GDecryptcell(en, dp.schemaopen);
                                        }
                                        if (en.cellid !== item.id)
                                            continue;
                                        // now we can do some clever filtering and we done!!
                                        let cons = srit.conds;
                                        if (cons && cons.length > 0) {
                                            // cons = filterInvalidConsitions(cons);
                                        }
                                        if (cons && cons.length > 0) {
                                            const rows = depschemarows.get(srit.sid);
                                            if (!rows)
                                                continue;
                                            const myens = [];
                                            const rind = en.rowid;
                                            for (const r of rows) {
                                                if (r.rowid === rind) {
                                                    for (const e1 of r.entry) {
                                                        myens.push(e1);
                                                    }
                                                }
                                            }
                                            if (!canShowRemoteEntry(en, cons, myens)) {
                                                continue;
                                            }
                                        }
                                        if (item.type === SchemaItemType.Text) {
                                            (_c = this.dependentdata.get(id)) === null || _c === void 0 ? void 0 : _c.push({
                                                id: en.id,
                                                value: (_d = stripHTML(en.celldata)) !== null && _d !== void 0 ? _d : ''
                                            });
                                        }
                                        else if (item.type === SchemaItemType.Date) {
                                            (_e = this.dependentdata.get(id)) === null || _e === void 0 ? void 0 : _e.push({
                                                id: en.id,
                                                value: DateLib.displayDateWIthFormat(en.celldata, item.inlcudetime, (_f = item.excludedate) !== null && _f !== void 0 ? _f : false)
                                            });
                                        }
                                        else {
                                            (_g = this.dependentdata.get(id)) === null || _g === void 0 ? void 0 : _g.push({
                                                id: en.id,
                                                value: en.celldata
                                            });
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
            }
        });
    }
    setLoadedRows(count) {
        this.loadedentry = count;
    }
    decryptRule(fitem) {
        var _a;
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        if (fitem.rule) {
            try {
                const val = LetrwingCrypto.decryptSecretBox(fitem.rule, key);
                if (val) {
                    const rv = JSON.parse(val);
                    if (rv) {
                        let validrule = false;
                        for (const pr of rv.rule) {
                            for (const rrv of pr.params) {
                                if (rrv.value && rrv.value.split("~~~").length > 2) {
                                    validrule = true;
                                    break;
                                }
                            }
                        }
                        if (validrule) {
                            fitem.ruleopen = rv;
                        }
                    }
                }
            }
            catch (ex) { }
        }
    }
    checkSchemaCellHasRule(cellid) {
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return false;
        }
        if (achema.rules) {
            for (const ar of achema.rules) {
                if (ar.colid === cellid) {
                    return true;
                }
            }
        }
        return false;
    }
    checkRowCellhasRule(rowid, cellid) {
        const rules = this.rowRules.get(this.activeschema + "~~~" + rowid);
        if (rules) {
            for (const ru of rules.data) {
                if (ru.colid === cellid) {
                    return true;
                }
            }
        }
        return this.checkSchemaCellHasRule(cellid);
    }
    checkCellHasRule(fitem) {
        return this.checkRowCellhasRule(fitem.rowid, fitem.cellid);
    }
    redoRowRule(row) {
        for (const en of row.entry) {
            if (en.ruleopen) {
                en.decrypted = false;
            }
        }
    }
    parseCellRule(fitem) {
        var _a;
        if (!this.activeschema) {
            return;
        }
        if (this.parsingentry.has(fitem.id) || fitem.decrypted) {
            return;
        }
        // we should now add this entry in the parsing stuff
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        this.parsingentry.add(fitem.id);
        if (fitem.ruleopen) {
            const wen = Object.assign({}, fitem);
            // lets now rebuild this rule now
            if (!this.depschemarows.has(this.activeschema) ||
                ((_a = this.depschemarows.get(this.activeschema)) === null || _a === void 0 ? void 0 : _a.length) !== this.rowsMap.size) {
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
            }
            if (!this.schemasmap.has(this.activeschema)) {
                this.schemasmap.set(this.activeschema, achema);
            }
            parser([wen], achema, this.depschemarows, this.schemasmap);
            // now we have this cell done we just need to remove this cell from the 
            fitem.celldata = wen.celldata;
            fitem.decrypted = true;
        }
        this.removeIdfromParsing(fitem.id);
    }
    removeIdfromParsing(id) {
        this.parsingentry.delete(id);
    }
    decryptCell(fitem) {
        var _a, _b;
        if (fitem.decrypted) {
            return;
        }
        const hasrule = this.checkCellHasRule(fitem);
        if (this.fetchingdepend && hasrule) {
            this.waitingentries.push(fitem); // mark it so we can rebuild this once we ready with data
            return; // we cant do much here yet
        }
        if (hasrule) {
            if (!this.parsingentry.has(fitem.id)) {
                // if we have rule then we should just parse this now!!
                setTimeout(() => {
                    this.parseCellRule(fitem);
                }, 0);
            }
            return;
        }
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        if (fitem.celldata.startsWith("pbk---")) {
            if (!achema.schemaintegrationbox) {
                return;
            }
            let pk = "";
            try {
                const dstr = LetrwingCrypto.decryptSecretBox(achema.schemaintegrationbox, achema.accesskey);
                if (dstr) {
                    const djs = JSON.parse(dstr);
                    pk = djs.privatkey;
                }
            }
            catch (ex) { }
            if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
                pk = achema.parentschema.webformkeys.priavatekey;
            }
            if (!pk) {
                fitem.celldata = '';
                console.log("missing key for rule parsing");
                return;
            }
            try {
                const emsg = fitem.celldata.substring("pbk---".length);
                const jsonstring = LetrwingCrypto.getUTF8FromBase64(emsg);
                const js = JSON.parse(jsonstring);
                const rawdata = LetrwingCrypto.decryptRSABoxRawString(js, { privatkey: pk, publickey: '' });
                fitem.celldata = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.cellfindstr = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.decrypted = true;
            }
            catch (ex) {
                console.log(ex);
            }
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_b = achema.parentschema) === null || _b === void 0 ? void 0 : _b.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        const val = LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.celldata, nonce: '', publickey: '' }, key, nonce);
        fitem.celldata = val !== null && val !== void 0 ? val : '';
        if (fitem.cellfindstr) {
            const val = LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.cellfindstr, nonce: '', publickey: '' }, key, nonce);
            fitem.cellfindstr = val !== null && val !== void 0 ? val : '';
        }
        else {
            fitem.cellfindstr = '';
        }
        //lets also attach display value here!!
        fitem.decrypted = true;
    }
    clearAns() {
        this.anas.clear();
        this.anasschema.clear();
    }
    collectRowsAndBuildRulesResult() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        // lets do this now
        let entries = [];
        // lets check the rules first 
        let solid = new Set();
        let haverules = false;
        if (req.rules) {
            for (const cr of req.rules) {
                for (const pr of cr.rule) {
                    let breakit = false;
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema')
                            continue;
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            const parts = rrv.value.split("~~~");
                            if ((parts[0] !== req.datasheetid || parts[1] !== req.id)) {
                                if (this.depschemarows.has(parts[1])) {
                                    // lets check if the row has the column
                                    const cid = parts[2];
                                    const sh = this.depschemarows.get(parts[1]);
                                    if (sh && sh.length > 0) {
                                        const r1 = sh[0];
                                        let had = false;
                                        for (const re of r1.entry) {
                                            if (re.cellid === cid) {
                                                had = true;
                                                break;
                                            }
                                        }
                                        if (had)
                                            continue;
                                    }
                                }
                                haverules = true;
                                breakit = true;
                                break;
                            }
                        }
                    }
                    if (breakit) {
                        break;
                    }
                }
            }
        }
        if (this.rowRules.size > 0 && !haverules) {
            for (const r of this.rowRules.values()) {
                for (const cr of r.data) {
                    for (const pr of cr.rule) {
                        let breakit = false;
                        for (const rrv of pr.params) {
                            if (rrv.type !== 'schema')
                                continue;
                            if (rrv.value && rrv.value.split("~~~").length > 2) {
                                const parts = rrv.value.split("~~~");
                                if (parts[0] !== req.datasheetid || parts[1] !== req.id) {
                                    if (this.depschemarows.has(parts[1])) {
                                        // lets check if the row has the column
                                        const cid = parts[2];
                                        const sh = this.depschemarows.get(parts[1]);
                                        if (sh && sh.length > 0) {
                                            const r1 = sh[0];
                                            let had = false;
                                            for (const re of r1.entry) {
                                                if (re.cellid === cid) {
                                                    had = true;
                                                    break;
                                                }
                                            }
                                            if (had)
                                                continue;
                                        }
                                    }
                                    haverules = true;
                                    breakit = true;
                                    break;
                                }
                            }
                        }
                        if (breakit) {
                            break;
                        }
                    }
                }
            }
        }
        for (const row of this.rowsMap.values()) {
            entries.push(...row.entry);
        }
        // now we have the all the entries that need something to be done!1
        if (haverules) {
            this.setFeatchingDepende(true);
            // lets get dependnt and we done then 
            const req1 = {
                letrid: this.activelterid,
                schemaid: this.activeschema,
                sh: req,
                en: entries,
                rules: Array.from(this.rowRules.values()),
                userid: this.activeuserid
            };
            // this is coole stuff now!!
            Apphandler.sendMessage("admindependententries", req1);
        }
        else {
            this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()));
        }
        this.setCollectingData(false);
    }
    setCollectingData(col) {
        this.checkingandcollecting = col;
    }
    setGettingAns(gett) {
        this.gettinganas = gett;
    }
    getAnalytics() {
        if (this.anas.size != 0)
            return; //we shou
        if (this.gettinganas)
            return;
        this.setGettingAns(true);
        const req = {
            letrid: this.activelterid,
            floating: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminschemaanalytics", req);
    }
    setGanttTaskField(id) {
        this.ganttasknameid = id;
    }
    setUpdatingDatasheet(updating) {
        this.updatingdatasheet = updating;
    }
    addSchemaToRowChList(rid, sid) {
        const row = this.rowsMap.get(rid);
        if (row) {
            if (!row.childrenschemalist) {
                row.childrenschemalist = [];
            }
            if (row.childrenschemalist.indexOf(sid) === -1) {
                row.childrenschemalist.push(sid);
            }
            this.updateRow(row.rowid, []);
        }
    }
    removeSchemaFromRowChList(id, sid) {
        var _a, _b, _c;
        const row = this.rowsMap.get(id);
        if (row) {
            const index = (_a = row.childrenschemalist) === null || _a === void 0 ? void 0 : _a.indexOf(sid);
            if (index !== undefined && index > -1) {
                (_b = row.childrenschemalist) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
                this.updateRow(row.rowid, []);
                if (this.activerowid === row.rowid &&
                    ((_c = row.childrenschemalist) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                    this.setActiveTab('detail');
                }
            }
        }
    }
    setGanttTaskFieldName(name) {
        this.ganttasknamefieldname = name;
    }
    setSavingRow(saving) {
        this.savingrow = saving;
    }
    setActiveChildSchema(id) {
        this.activechildschema = id;
    }
    setShowDerviedSchemaFields(show) {
        this.showdervivedschemafields = show;
        // lets rebuild 
    }
    setAuthor(n) {
        this.authors.set(n.authorid, {
            authorid: n.authorid,
            authorname: n.authorname
        });
    }
    setShowActions(show) {
        this.showactions = show;
    }
    setDeleting(del) {
        this.deletingschema = del;
    }
    removeDeletingNote(dn) {
        this.deletenoteids.delete(dn);
    }
    resetFilter() {
        this.notesbyid.forEach((n, k) => {
            if (n.note !== undefined) {
                n.setVisible(true);
            }
        });
    }
    setEnableAnnotation(enable) {
        this.enableannotation = enable;
    }
    setActiveAction(act) {
        this.activeaction = act;
        this.setShowActions(false);
    }
    deleteLink(link) {
        const id = this.links.indexOf(link);
        if (id !== undefined && id > -1) {
            this.links.splice(id, 1);
        }
    }
    addIdToRemovingCh(id) {
        this.removingrowsfromsh.add(id);
    }
    removeIdToRemovingCh(id) {
        this.removingrowsfromsh.delete(id);
    }
    setNoteLinksDialogLeft(left) {
        this.notelinksdialogleft = left;
    }
    setNoteLinksDialogTop(top) {
        this.notelinksdialogtop = top;
    }
    setSelectedRow(id) {
        this.selectedrows.set(id.rowid, id);
    }
    setUnSelectedRow(id) {
        this.selectedrows.delete(id);
        if (this.selectedrows.size === 0) {
            this.setActiveAction("unknown");
        }
    }
    selectAllRow() {
        this.rowsMap.forEach((rm) => this.setSelectedRow(rm));
        this.selectallrows = true;
    }
    unselectAllRow() {
        this.rowsMap.forEach((rm) => this.setUnSelectedRow(rm.rowid));
        this.selectallrows = false;
    }
    setAddingRowToChildren(adding) {
        this.addingrowtochild = adding;
    }
    setShowLinksForNote(noteid) {
        this.showinoutlinks.add(noteid);
    }
    clearShowLinksForNote() {
        this.showinoutlinks.clear();
    }
    removeShowLinksForNote(noteid) {
        this.showinoutlinks.delete(noteid);
    }
    setLoadingNotes(loading) {
        this.loadingnotes = loading;
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    addNote(note) {
        this.notesbyid.set(note.id, this.convertNoteToNoteUI(note));
    }
    setDeletingNote(dn) {
        this.deletenoteids.add(dn);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (!mode) {
            this.activeaccessids = new Set([ALLViewer]);
            this.appliedaclstr = "---";
        }
    }
    setShowFilter(show) {
        this.showfilter = show;
    }
    setSavingNote(saving) {
        this.savingnote = saving;
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.lastcommenttime = -1;
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    setLoadingChat(loading) {
        this.loadingchats = loading;
    }
    getAllNotes() {
        if (this.loadingnotes || !this.activerowid ||
            !this.activeschema || !this.activelterid || !this.activeuserid) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.activeloadednotesref = "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            ischooser: false,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetnotes", req);
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
    }
    convertNoteToNoteUI(note) {
        const noteui = new DraftNoteUI(note);
        noteui.setNote(note);
        noteui.setVisible(true);
        return noteui;
    }
    clearLinks() {
        this.links.splice(0, this.links.length);
    }
    removeNote(nid) {
        this.notesbyid.delete(nid);
    }
    setAppliedAclString(str) {
        this.appliedaclstr = str;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    getChatUpdate() {
        if (this.loadingchats || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid) {
            return;
        }
        const comms = this.chatstate.getComments();
        if (this.lastchattime == -1) {
            this.lastchattime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastchattime,
            noteid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getCommentUpdate() {
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid
            || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastnotesupdatetime,
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    setStartNotes(start) {
        this.startnotes = start;
    }
    updateRow(id, entry) {
        var _a, _b;
        let rindex = -1;
        const row = this.rowsMap.get(id);
        if (row) {
            for (const en of entry) {
                let eindex = -1;
                for (let i = 0; i < row.entry.length; i++) {
                    const ren = row.entry[i];
                    if (ren.cellid === en.cellid) {
                        eindex = i;
                    }
                }
                if (eindex > -1) {
                    row.entry.splice(eindex, 1, en);
                }
                else {
                    row.entry.push(en);
                }
            }
            this.rowsMap.set(id, row);
            if (this.activeview === 'card') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildCardItem(row, achema, this.activecardsttaus, this.activecardgroupby);
                    if (item) {
                        this.kanbanstatus.updateCard(item);
                    }
                }
                // lets build this card now!
            }
            else if (this.activeview === 'calendar') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildCalendarCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                    if (item) {
                        item.extraprop = (_a = this.calendarstate.elements.get(item.id)) === null || _a === void 0 ? void 0 : _a.extraprop;
                        this.calendarstate.updateElement(item.id, item);
                    }
                }
            }
            else if (this.activeview === 'gantt') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildGanttCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                    if (item) {
                        item.extraprop = (_b = this.timelinestatus.timelinecards.get(item.id)) === null || _b === void 0 ? void 0 : _b.extraprop;
                        this.timelinestatus.updateElement(item.id, item);
                    }
                }
            }
            else if (this.activeview === 'chart') {
                if (this.chartstate.size > 0) {
                    for (const ct of Array.from(this.chartstate.values())) {
                        this.buildChart(ct.id, ct.xid, ct.yid, ct.ctype, ct.colorfield);
                    }
                }
            }
        }
    }
    setActiveTab(tab) {
        this.activedetailtab = tab;
        if ((tab === 'notes' || tab === 'inbound') &&
            this.activeloadednotesref !== "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
            this.getAllNotes();
        }
    }
    setShowLinkDialog(show) {
        this.showlinkdialog = show;
    }
    setFilter(filter) {
        for (const n of this.notesbyid.values()) {
            if (n.note !== undefined) {
                if (filter.toDate !== undefined && filter.toDate > 0) {
                    if (n.note.updatetime <= filter.toDate) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromDate !== undefined && filter.fromDate > 0) {
                    if (n.note.updatetime >= filter.fromDate - 1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.toPage !== undefined && filter.toPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg <= filter.toPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromPage !== undefined && filter.fromPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg >= filter.fromPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.type != undefined && filter.type.length > 0) {
                    if (filter.type.indexOf(n.note.data.notetype) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.authors != undefined && filter.authors.length > 0) {
                    if (filter.authors.indexOf(n.note.authorid) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.notetype.length > 0) {
                    if (n.note.linkboxes !== undefined && n.note.linkboxes.length > 0 && filter.notetype.indexOf(n.note.type) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.filterlinknote) {
                    if (n.note.linkboxes === undefined) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                n.setVisible(true);
            }
        }
    }
    setNotesLoading(load) {
        this.schemanotesloading = load;
    }
    saveActiveRowEdits() {
        var _a, _b;
        let arow = this.rowsMap.get(this.activerowid);
        if (!this.activeschema || !arow) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        if (this.editrowproperty.size === 0) {
            return;
        }
        this.setSavingRow(true);
        // now lets just save thes evalues and we done hurraty!!
        const cellmap = new Map();
        for (const shi of (_b = (_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) {
            cellmap.set(shi.id, shi);
            const sentry = this.editrowproperty.get(shi.id);
            if (shi.required && sentry && !sentry.celldata) {
                APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                this.setSavingRow(false);
                return;
            }
        }
        for (const shi of achema.items) {
            cellmap.set(shi.id, shi);
            const sentry = this.editrowproperty.get(shi.id);
            if (shi.required && sentry && !sentry.celldata) {
                APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                this.setSavingRow(false);
                return;
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                for (const shi of sh.items) {
                    cellmap.set(shi.id, shi);
                    const sentry = this.editrowproperty.get(shi.id);
                    if (shi.required && sentry && !sentry.celldata) {
                        APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                        this.setSavingRow(false);
                        return;
                    }
                }
            }
        }
        const sh = achema;
        const sentries = [];
        for (const [k, val] of this.editrowproperty) {
            const citem = cellmap.get(k);
            if (citem) {
                if (citem.type === SchemaItemType.Number) {
                    let sortstring = -1;
                    if (val.celldata.indexOf(".") > -1) {
                        sortstring = sh.numberoffset + parseFloat(val.celldata);
                    }
                    else {
                        sortstring = sh.numberoffset + parseInt(val.celldata);
                    }
                    val.sortstring = sortstring;
                }
                else if (citem.type === SchemaItemType.Date) {
                    if (val.celldata) {
                        val.sortstring = sh.dateoffset + parseInt(val.celldata);
                    }
                }
                sentries.push(val);
            }
        }
        let key = sh.accesskey;
        let nonce = sh.nonce;
        if (arow.entry[0].schemaid !== this.activeschema) {
            if (!sh.parentschema) {
                return;
            }
            key = sh.parentschema.accesskey;
            nonce = sh.parentschema.nonce;
        }
        if (sentries.length > 0) {
            const reqid = Math.random() + "";
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                reqid: reqid,
                entries: sentries,
                accesskey: key,
                nonce: nonce,
                rowid: this.activerowid,
                duplicaterequest: false,
                schemaitems: [],
                assigns: [],
                nvs: []
            };
            this.activereqid = reqid;
            Apphandler.sendMessage("updaterow", req);
        }
        else {
            this.setSavingRow(false);
        }
    }
    setDeleteingRows(del) {
        this.deleteingrows = del;
    }
    deleteRows() {
        if (this.selectedrows.size > 0) {
            const dids = Array.from(this.selectedrows.keys());
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                rids: dids
            };
            this.setDeleteingRows(true);
            Apphandler.sendMessage("deleterows", req);
        }
    }
    setShowGanttStartDate(show) {
        this.showganttstartdate = show;
    }
    setShowChartMenu(show) {
        this.showchartmenu = show;
    }
    setShowGanttStartDateName(show) {
        this.showganttstartdatename = show;
    }
    setShowGanttEndDateName(show) {
        this.showganttenddatename = show;
    }
    setShowGanttEndDate(show) {
        this.showganttenddate = show;
    }
    setShowColorField(show) {
        this.showcolorfield = show;
    }
    setColorFieldId(id) {
        this.colorfieldid = id;
    }
    setColorFieldName(id) {
        this.colorfieldname = id;
    }
    setActiveRowId(id) {
        if (id) {
            // Router.setActiveRowid(id);
        }
        this.removingrowsfromsh.clear();
        this.activeloadednotesref = "";
        this.activerowid = id;
        this.chatstate.clear();
        this.editrowproperty.clear();
        this.setSavingRow(false);
        if (id) {
            this.setActiveTab("notes");
        }
        else {
            this.setActiveTab("detail");
        }
        this.setLoadingChat(false);
        if (id) {
            // this.loadChats();
        }
        this.resetNotes();
    }
    removePropertiesFromActiveRow(id) {
        this.editrowproperty.delete(id);
    }
    setPropertiesForActiveRow(id, entry) {
        this.editrowproperty.set(id, entry);
    }
    setShowDescField(show) {
        this.showdescfield = show;
    }
    setDescFieldId(id) {
        this.descfieldid = id;
    }
    setDescFieldName(id) {
        this.descfieldname = id;
    }
    setGanttStartDate(show) {
        this.ganttstartid = show;
    }
    removeChartState(id) {
        this.chartstate.delete(id);
    }
    setGanttEndDate(show) {
        this.ganttendid = show;
    }
    setActiveGroupByMenu(show) {
        this.showgroupbymenu = show;
    }
    setShowStatusesMenu(show) {
        this.showstatuesmenu = show;
    }
    setActiveCardStatusName(st) {
        this.activecardstatusname = st;
    }
    setActiveCardGroupName(st) {
        this.activecardgroupname = st;
    }
    setActiveCardStatus(st) {
        if (this.activecardsttaus === st) {
            return;
        }
        this.activecardsttaus = st;
        setTimeout(() => this.updateCardView(), 10);
        // lets set these infomration and we done
    }
    setActiveCardGroup(st) {
        if (this.activecardgroupby === st || !this.activecardsttaus) {
            return;
        }
        this.activecardgroupby = st;
        setTimeout(() => this.updateCardView(), 10);
    }
    updateCardView() {
        this.kanbanstatus.clear();
        this.kanbanstatus.setBuildingView(true);
        const cards = this.buildCardView(this.activecardsttaus, this.activecardgroupby);
        const statuses = this.getAllFieldsForItem(this.activecardsttaus);
        this.kanbanstatus.setStatuses(statuses.map((st) => {
            const ret = {
                id: st.id,
                label: st.name
            };
            return ret;
        }));
        if (this.activecardgroupby && this.activecardgroupby !== this.activecardsttaus) {
            const grps = this.getAllFieldsForItem(this.activecardgroupby);
            this.kanbanstatus.setGroupBy(grps.map((st) => {
                const ret = {
                    id: st.id,
                    label: st.name
                };
                return ret;
            }));
        }
        cards === null || cards === void 0 ? void 0 : cards.forEach((cd) => this.kanbanstatus.addCard(cd));
        this.kanbanstatus.setBuildingView(false);
    }
    setActiveDatasheet(did) {
        this.reset();
        this.activedatasheet = did;
        // Router.setActiveDatasheet(did);
        this.setLoading(true);
        this.loadSchemas();
    }
    loadSchemas() {
        const req = {
            letrid: this.activelterid,
            datasheetid: this.activedatasheet,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetschemas", req);
    }
    buildCalendarTask(sd, render, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.calendarstate.clear();
        this.setActiveRowId("");
        this.calendarstate.setBuilding(true);
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let index = 0;
        for (const [k, item] of this.rowsMap) {
            const citem = new CardItem();
            let use = false;
            const epopr = new Map();
            epopr.set("rowindex", index++ + '');
            let cevent = {
                id: item.rowid,
                rangedates: [],
                displayItem: citem,
                extraprop: epopr,
                color: this.colors[Math.floor(Math.random() * 3)],
            };
            for (const fitem of item.entry) {
                if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                    && (!desfield || fitem.cellid !== desfield)
                    && (!colorfield || fitem.cellid !== colorfield)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === sd) {
                    try {
                        cevent.rangedates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (ed && fitem.cellid === ed) {
                    try {
                        cevent.rangedates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (colorfield && fitem.cellid === colorfield) {
                    cevent.color = value;
                    continue;
                }
                const sitem = sitemmap.get(fitem.cellid);
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                }
                citem.addDisplayField(fitem.cellid, {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                    sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                    columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                    isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
                });
            }
            if (use) {
                this.calendarstate.addElement(cevent.id, cevent);
            }
        }
        this.calendarstate.setBuilding(false);
    }
    buildGanttCard(item, sd, achema, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let use = false;
        const citem = new CardItem();
        const tlitem = {
            id: item.rowid,
            displayitems: citem,
            displaydate: '',
            rangeDates: [],
            color: this.colors[Math.floor(Math.random() * 3)],
        };
        for (const fitem of item.entry) {
            if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                && (!desfield || fitem.cellid !== desfield)
                && (!colorfield || fitem.cellid !== colorfield)) {
                continue;
            }
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (!value) {
                continue;
            }
            if (fitem.cellid === sd) {
                try {
                    tlitem.rangeDates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (ed && fitem.cellid === ed) {
                try {
                    tlitem.rangeDates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (colorfield && fitem.cellid === colorfield) {
                tlitem.color = value;
                continue;
            }
            const sitem = sitemmap.get(fitem.cellid);
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
            }
            tlitem.displayitems.addDisplayField(fitem.cellid, {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
            });
        }
        if (use) {
            return tlitem;
        }
        return undefined;
    }
    buildCalendarCard(item, sd, achema, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        const citem = new CardItem();
        let use = false;
        let cevent = {
            id: item.rowid,
            rangedates: [],
            displayItem: citem,
            color: this.colors[Math.floor(Math.random() * 3)],
        };
        for (const fitem of item.entry) {
            if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                && (!desfield || fitem.cellid !== desfield)
                && (!colorfield || fitem.cellid !== colorfield)) {
                continue;
            }
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (!value) {
                continue;
            }
            if (fitem.cellid === sd) {
                try {
                    cevent.rangedates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (ed && fitem.cellid === ed) {
                try {
                    cevent.rangedates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (colorfield && fitem.cellid === colorfield) {
                cevent.color = value;
                continue;
            }
            const sitem = sitemmap.get(fitem.cellid);
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                const items = sitem.items.filter((it) => it.id === fitem.celldata);
                if (items.length > 0) {
                    value = items[0].name;
                }
                else {
                    value = "";
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
            }
            citem.addDisplayField(fitem.cellid, {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
            });
        }
        if (use) {
            return cevent;
        }
        return undefined;
    }
    buildGanTTTask(sd, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.timelinestatus.clear();
        this.setActiveRowId("");
        this.timelinestatus.setBuildingView(true);
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let index = 0;
        for (const [k, item] of this.rowsMap) {
            let use = false;
            const citem = new CardItem();
            const epopr = new Map();
            epopr.set("rowindex", index++ + '');
            const tlitem = {
                id: item.rowid,
                displayitems: citem,
                displaydate: '',
                rangeDates: [],
                color: this.colors[Math.floor(Math.random() * 3)],
                extraprop: epopr
            };
            for (const fitem of item.entry) {
                if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                    && (!desfield || fitem.cellid !== desfield)
                    && (!colorfield || fitem.cellid !== colorfield)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === sd) {
                    try {
                        tlitem.rangeDates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (ed && fitem.cellid === ed) {
                    try {
                        tlitem.rangeDates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (colorfield && fitem.cellid === colorfield) {
                    tlitem.color = value;
                    continue;
                }
                const sitem = sitemmap.get(fitem.cellid);
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                    const items = sitem.items.filter((it) => it.id === fitem.celldata);
                    if (items.length > 0) {
                        value = items[0].name;
                    }
                    else {
                        value = "";
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                    value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                }
                tlitem.displayitems.addDisplayField(fitem.cellid, {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                    sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                    columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                    isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
                });
            }
            if (use) {
                this.timelinestatus.setTimelineCard(tlitem);
            }
        }
        this.timelinestatus.setBuildingView(false);
    }
    getAllFieldsForItem(itemid) {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let csitems = [];
        if (achema.parentschema) {
            csitems.push(...achema.parentschema.items);
        }
        csitems.push(...achema.items);
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                csitems.push(...sh.items);
            }
        }
        const sitems = csitems.find((ite) => ite.id === itemid);
        if (!sitems) {
            return [];
        }
        return sitems.items;
    }
    getAllNumberFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Number) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Number) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllTextFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Text) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Text) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllColorFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Color) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Color) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        sitems.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const items = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                sitems.push(...items);
            }
        }
        return sitems;
    }
    getAllDateFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        sitems.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Date) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Date) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllCardViewChoiceFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        sitems.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Choice) {
                const fieldtype = field;
                if (fieldtype.items && fieldtype.items.length > 0) {
                    ret.push(fieldtype);
                }
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const field of sitems) {
                if (field.type === SchemaItemType.Choice) {
                    const fieldtype = field;
                    if (fieldtype.items && fieldtype.items.length > 0) {
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    buildCardItem(item, achema, fieldid, groupby) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const sitemmap = new Map();
        const dname = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => {
                    sitemmap.set(item.id, item);
                    dname.set(item.id, sh.name);
                });
            }
        }
        const activestatusfields = new Map();
        const activegroupfields = new Map();
        const fields = sitemmap.get(this.activecardsttaus);
        if (fields) {
            fields.items.forEach((it) => activestatusfields.set(it.id, it.name));
        }
        const grous = sitemmap.get(this.activecardgroupby);
        if (grous) {
            grous.items.forEach((it) => activegroupfields.set(it.id, it.name));
        }
        let use = true;
        const itemcard = new CardItem();
        itemcard.cradid = item.rowid;
        for (const fitem of item.entry) {
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (fitem.cellid === fieldid) {
                // okay good
                if (!fitem.celldata) {
                    use = false;
                    break;
                }
                itemcard.setStatus(fitem.celldata);
            }
            else if (groupby && groupby !== fieldid && fitem.cellid === groupby) {
                itemcard.setGroupid(fitem.celldata);
            }
            const sitem = sitemmap.get(fitem.cellid);
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                const items = sitem.items.filter((it) => it.id === fitem.celldata);
                if (items.length > 0) {
                    value = items[0].name;
                }
                else {
                    value = "";
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
            }
            let cname = (_d = (_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            const shname = dname.get(fitem.cellid);
            if (shname) {
                cname += " (" + shname + ")";
            }
            itemcard.addDisplayField(fitem.cellid, {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.type) === SchemaItemType.Number ? AlignMent.Right : (_f = AlignMent.Left) !== null && _f !== void 0 ? _f : AlignMent.Left,
                sortindex: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.orderindex) !== null && _h !== void 0 ? _h : -1,
                columnname: cname,
                isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
            });
        }
        if (use) {
            return itemcard;
        }
        return undefined;
    }
    // if no groupby then we can just really build anything
    buildCardView(fieldid, groupby) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitemmap = new Map();
        const dname = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => {
                    sitemmap.set(item.id, item);
                    dname.set(item.id, sh.name);
                });
            }
        }
        this.activebuilingid = Math.random();
        const activestatusfields = new Map();
        const activegroupfields = new Map();
        const fields = sitemmap.get(this.activecardsttaus);
        if (fields) {
            fields.items.forEach((it) => activestatusfields.set(it.id, it.name));
        }
        const grous = sitemmap.get(this.activecardgroupby);
        if (grous) {
            grous.items.forEach((it) => activegroupfields.set(it.id, it.name));
        }
        const buildid = this.activebuilingid;
        const cards = [];
        let index = 0;
        for (const [_, item] of this.rowsMap) {
            // this should never happen but lets keep it for now
            // if we do closure in future
            if (this.activebuilingid !== buildid) {
                return;
            }
            let use = true;
            const itemcard = new CardItem();
            itemcard.cardindex = index++;
            itemcard.cradid = item.rowid;
            for (const fitem of item.entry) {
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (fitem.cellid === fieldid) {
                    // okay good
                    if (!fitem.celldata) {
                        use = false;
                        break;
                    }
                    itemcard.setStatus(fitem.celldata);
                }
                else if (groupby && groupby !== fieldid && fitem.cellid === groupby) {
                    itemcard.setGroupid(fitem.celldata);
                }
                const sitem = sitemmap.get(fitem.cellid);
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                    const items = sitem.items.filter((it) => it.id === fitem.celldata);
                    if (items.length > 0) {
                        value = items[0].name;
                    }
                    else {
                        value = "";
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                    value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                }
                let cname = (_d = (_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
                const shname = dname.get(fitem.cellid);
                if (shname) {
                    cname += " (" + shname + ")";
                }
                itemcard.addDisplayField(fitem.cellid, {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    alignment: ((_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.type) === SchemaItemType.Number ? AlignMent.Right : (_f = AlignMent.Left) !== null && _f !== void 0 ? _f : AlignMent.Left,
                    sortindex: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.orderindex) !== null && _h !== void 0 ? _h : -1,
                    columnname: cname,
                    isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false !== null && false !== void 0 ? false : false
                });
            }
            if (use) {
                cards.push(itemcard);
            }
        }
        return cards;
    }
    setShowActiveView(show) {
        this.showactiveviewmenu = show;
    }
    setBuildingView(building) {
        this.buildingview = building;
    }
    setActiveView(view) {
        this.activeview = view;
    }
    addSchema(sch) {
        this.schemas.set(sch.id, sch);
    }
    removeSchema(sch) {
        this.schemas.delete(sch);
        if (this.activeschema === sch) {
            const sha = Array.from(this.schemas.values());
            if (sha.length > 0) {
                this.setActiveSchema(sha[0].id);
            }
            else {
                this.setActiveSchema("");
            }
        }
    }
    async addRowInline(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.rowsMap.set(r.rowid, r);
            if (index > 0 && index % 1000 == 0) {
                await timeout(100);
            }
            ;
            index++;
        }
        await timeout(10);
    }
    async addRows(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.addRow(r);
            if (index > 0 && index % 1000 === 0) {
                await timeout(10);
            }
            index++;
        }
    }
    arrangeListCells(en) {
        // the way to arrange these will be via the 
        var _a;
        en.sort((en1, en2) => {
            var _a, _b;
            const s1 = (_a = en1.subrowindex) !== null && _a !== void 0 ? _a : -1;
            const s2 = (_b = en2.subrowindex) !== null && _b !== void 0 ? _b : -1;
            if (s1 === -1 && s2 === -1) {
                return 0;
            }
            if (s1 === -1) {
                return 1;
            }
            if (s2 === -1) {
                return -1;
            }
            const parts1 = s1.split("----");
            const parts2 = s2.split("----");
            if (parts1[0] === parts2[0]) {
                // if(parts1.length < 2 || parts2.length < 2) {
                //     return -1;
                // }
                return parts1[1].localeCompare(parts2[1]);
            }
            return parseInt(parts1[0]) - parseInt(parts2[0]);
        });
        let trow = [];
        const rows = [];
        for (const e of en) {
            const s1 = (_a = e.subrowindex) !== null && _a !== void 0 ? _a : -1;
            if (s1 !== -1) {
                if (trow.indexOf(s1) === -1) {
                    trow.push(s1);
                }
            }
        }
        return trow;
    }
    addRuleEntryToRow(row) {
        var _a;
        const rulebycellid = new Map();
        const sh = this.schemas.get(this.activeschema);
        if (sh && sh.rules) {
            for (const rule of sh.rules) {
                rulebycellid.set(rule.colid, rule);
            }
        }
        const rowrules = this.rowRules.get(this.activeschema + "~~~" + row.rowid);
        const rowrmap = new Map();
        if (rowrules) {
            for (const r of rowrules.data) {
                rowrmap.set(r.colid, r);
            }
        }
        for (const [k, v] of rulebycellid) {
            if (!rowrmap.has(k)) {
                rowrmap.set(k, v);
            }
        }
        const emap = new Map();
        for (const en of row.entry) {
            const id = en.cellid.split("----");
            if (!emap.has(id[0])) {
                emap.set(id[0], []);
            }
            let colrule = rulebycellid.get(en.cellid);
            if (rowrmap.size > 0) {
                let cr = rowrmap.get(en.cellid);
                if (cr) {
                    colrule = cr;
                }
            }
            if (en.ruleopen) {
                //if this already had it
                en.decrypted = false;
            }
            en.ruleopen = colrule;
            if (en.ruleopen) {
                // new rule 
                en.decrypted = false;
            }
            (_a = emap.get(id[0])) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        // now lets go over all cells needing rule
        for (const [k, v] of rowrmap) {
            if (k.indexOf("----") !== -1) {
                // lets add entry to this as well now!
                const parts = k.split("----");
                const ens = emap.get(parts[0]);
                if (!ens || (ens === null || ens === void 0 ? void 0 : ens.length) === 0)
                    continue;
                // we have subrows lets add entry for each
                const subrows = this.arrangeListCells(ens);
                const entrymap = new Map();
                // now we have these subrows lets see if we can make sense of this now
                for (const en of ens) {
                    if (!en.subrowindex)
                        continue;
                    entrymap.set(en.cellid + "----" + en.subrowindex, en);
                }
                for (const sr of subrows) {
                    const sid = k + "----" + sr;
                    if (!entrymap.has(sid)) {
                        let en = {
                            celldata: '',
                            cellfindstr: '',
                            cellid: k,
                            schemaid: this.activeschema,
                            rowindex: row.rowindex,
                            rowid: row.rowid,
                            subrowindex: sr,
                            id: LetrwingCrypto.getUUID(),
                            sortstring: Math.random(),
                            decrypted: false
                        };
                        const id = en.cellid.split("----");
                        if (!emap.has(id[0])) {
                            emap.set(id[0], []);
                        }
                        let colrule = rulebycellid.get(en.cellid);
                        if (rowrmap.size > 0) {
                            let cr = rowrmap.get(en.cellid);
                            if (cr) {
                                colrule = cr;
                            }
                        }
                        en.ruleopen = colrule;
                        row.entry.push(en);
                    }
                }
            }
            else {
                if (!emap.has(k)) {
                    let en = {
                        celldata: '',
                        cellfindstr: '',
                        cellid: k,
                        schemaid: this.activeschema,
                        rowindex: row.rowindex,
                        rowid: row.rowid,
                        subrowindex: "",
                        id: LetrwingCrypto.getUUID(),
                        sortstring: Math.random(),
                        decrypted: false
                    };
                    const id = en.cellid.split("----");
                    if (!emap.has(id[0])) {
                        emap.set(id[0], []);
                    }
                    let colrule = rulebycellid.get(en.cellid);
                    if (rowrmap.size > 0) {
                        let cr = rowrmap.get(en.cellid);
                        if (cr) {
                            colrule = cr;
                        }
                    }
                    en.ruleopen = colrule;
                    row.entry.push(en);
                }
            }
        }
    }
    addRuleEntryToRows() {
        for (const row of this.rowsMap.values()) {
            this.addRuleEntryToRow(row);
        }
    }
    addRow(row) {
        this.addRuleEntryToRow(row);
        this.rowsMap.set(row.rowid, row);
        if (this.activeview === 'card') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildCardItem(row, achema, this.activecardsttaus, this.activecardgroupby);
                if (item) {
                    item.cardindex = this.rowsMap.size - 1;
                    this.kanbanstatus.addCard(item);
                }
            }
            // lets build this card now!
        }
        else if (this.activeview === 'calendar') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildCalendarCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                if (item) {
                    const epopr = new Map();
                    epopr.set("rowindex", (this.rowsMap.size - 1) + '');
                    item.extraprop = epopr;
                    this.calendarstate.addElement(item.id, item);
                }
            }
        }
        else if (this.activeview === 'gantt') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildGanttCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                if (item) {
                    const epopr = new Map();
                    epopr.set("rowindex", (this.rowsMap.size - 1) + '');
                    item.extraprop = epopr;
                    this.timelinestatus.setTimelineCard(item);
                }
            }
        }
        else if (this.activeview === 'chart') {
            if (this.chartstate.size > 0) {
                for (const ct of Array.from(this.chartstate.values())) {
                    this.buildChart(ct.id, ct.xid, ct.yid, ct.ctype, ct.colorfield);
                }
            }
        }
    }
    addNewRow(nrow) {
        this.newrowsmap.push(nrow);
    }
    removeRow(index) {
        this.rowsMap.delete(index);
    }
    removeNewRow(index) {
        let nrin = -1;
        for (let i = 0; i < this.newrowsmap.length; i++) {
            const nr = this.newrowsmap[i];
            if (nr.rowindex === index) {
                nrin = i;
                break;
            }
        }
        this.newrowsmap.splice(nrin, 1);
    }
    setStoringForm(storing) {
        this.storingform = storing;
    }
    setLoadingContent(loading) {
        this.loadingcontent = loading;
    }
    setLoadmore(loading) {
        this.loadmore = loading;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    loadMoreRows() {
    }
    resetNotes() {
        this.notesbyid.clear();
        this.showinoutlinks.clear();
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
        this.setLoadingNotes(false);
        this.setAppliedAclString("");
        this.selectAccessids([ALLViewer]);
        this.setShowComments(false);
        this.commentstate.clear();
    }
    setShowComments(dn) {
        this.showcomments = dn;
    }
    hideColumn(id) {
        this.hiddencolumns.add(id);
    }
    setDuplicatingRows(dupl) {
        this.duplicating = dupl;
    }
    setDuplicatedCount(ct) {
        this.duplicatingcount = ct;
    }
    showColumn(id) {
        this.hiddencolumns.delete(id);
    }
    setShowColumns(cols) {
        this.showcolumnview = cols;
    }
    addRowRule(rule) {
        this.rowRules.set(rule.id, rule);
    }
    cleaRowRule() {
        this.rowRules.clear();
    }
    setFeatchingDepende(fetch) {
        this.fetchingdepend = fetch;
    }
    setActiveSchema(id) {
        this.setFeatchingDepende(false);
        this.depschemarows.clear();
        this.cleaRowRule();
        this.loadedentry = 0;
        this.waitingentries = [];
        this.schemadep = undefined;
        this.buildingrulefor.clear();
        this.buildingruleforscol.clear();
        this.colwithschemarules.clear();
        this.hiddenrows.clear();
        this.activeschemametaids.clear();
        this.storeschemaids.clear();
        this.enableallsel = false;
        this.removingrowsfromsh.clear();
        this.selectedrows.clear();
        this.setDeleteingRows(false);
        this.filterdialogstate.clear();
        // this.setShowRowFilter(false);
        this.setDuplicatingRows(false);
        this.setDuplicatedCount(0);
        this.drows = [];
        this.hiddencolumns.clear();
        this.setShowColumns(false);
        this.setActiveAction("unknown");
        this.setAddingRowToChildren(false);
        this.selectallrows = false;
        this.selectedrows.clear();
        this.resetNotes();
        this.activeschema = id;
        this.setActiveRowId("");
        this.formentry.clear();
        this.setActiveTab('notes');
        this.setActiveView("grid");
        this.kanbanstatus.clear();
        this.timelinestatus.clear();
        this.chartstate.clear();
        this.calendarstate.clear();
        this.activeloadednotesref = "";
        this.notesbyid.clear();
        this.setNotesLoading(false);
        this.setSavingRow(false);
        this.rowsMap.clear();
        this.newrowsmap.splice(0, this.newrowsmap.length);
        let items = [];
        const achema = this.schemas.get(id);
        if (achema === null || achema === void 0 ? void 0 : achema.parentschema) {
            items.push(...achema === null || achema === void 0 ? void 0 : achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        if (achema) {
            items.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        if (achema === null || achema === void 0 ? void 0 : achema.metaschemaids) {
            achema.metaschemaids.forEach(id => {
                this.activeschemametaids.add(id);
                this.storeschemaids.add(id);
            });
        }
        this.sortedschemaitems = items;
        this.loadSchemaEntries(true);
        if ((achema === null || achema === void 0 ? void 0 : achema.parentschema) && achema.parentschema.rules) {
            for (const cr of achema.parentschema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
        if (achema === null || achema === void 0 ? void 0 : achema.rules) {
            // lets go over them now!!
            for (const cr of achema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
    }
    loadSchemaEntries(force = false) {
        var _a, _b;
        if (this.loadingcontent || !this.activeschema || !this.activelterid || !this.activeuserid) {
            return;
        }
        if (this.loadingcontent && !force) {
            return;
        }
        const sh = this.schemas.get(this.activeschema);
        if (!sh) {
            return;
        }
        this.setLoadingContent(true);
        const cids = [];
        if (sh.items && sh.items.length > 0) {
            for (let i = 0; i < sh.items.length; i++) {
                const item = sh.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
        }
        if (sh.parentschema && sh.parentschema.items && sh.parentschema.items.length > 0) {
            for (let i = 0; i < sh.parentschema.items.length; i++) {
                const item = sh.parentschema.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
            // we should also add some of the things like 
        }
        if (sh.childrenschema && sh.childrenschema.length > 0) {
            for (const ch of sh.childrenschema) {
                if (ch.items && ch.items.length > 0) {
                    for (let i = 0; i < ch.items.length; i++) {
                        const item = ch.items[i];
                        cids.push(item.id);
                        if (item.type === SchemaItemType.List) {
                            const litem = item;
                            if (litem.items && litem.items.length > 0) {
                                cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                            }
                        }
                    }
                }
            }
        }
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            dataids: cids,
            floating: false,
            privatekey: (_b = (_a = sh.webformkeys) === null || _a === void 0 ? void 0 : _a.priavatekey) !== null && _b !== void 0 ? _b : '',
            schamenonce: sh.nonce,
            schemakey: sh.accesskey,
            sitems: sh.items,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetrows", req);
    }
    getRows() {
        return Array.from(this.rowsMap.values()).filter(row => !this.hiddenrows.has(row.rowid)).slice().sort((r1, r2) => r1.rowindex - r2.rowindex);
    }
    resetSchemaForm() {
        this.formentry.clear();
    }
    setShowForm(show) {
        this.showform = show;
    }
    addFormEntry(id, val) {
        this.formentry.set(id, val);
    }
    buildChart(id, xfield, yfield, ctype, colorid) {
        var _a, _b, _c;
        const cstate = this.chartstate.get(id);
        if (!cstate) {
            return;
        }
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        const field = sitemmap.get(xfield);
        const yfd = sitemmap.get(yfield);
        if (!field || !yfd) {
            return;
        }
        cstate.setBuildingChart(true);
        // now lets build this!!
        cstate.setChartType(ctype);
        cstate.setYName(yfd.name);
        cstate.setXName(field.name);
        cstate.setYID(yfd.id);
        cstate.setXID(field.id);
        if (colorid) {
            const cofile = sitemmap.get(colorid);
            if (cofile) {
                cstate.setColorFieldid(cofile === null || cofile === void 0 ? void 0 : cofile.id);
                cstate.setColorFieldName(cofile.name);
            }
        }
        const xdata = [];
        const ydata = [];
        let index = -1;
        for (const [_, item] of this.rowsMap) {
            index++;
            let mycolor = this.colors[Math.floor(Math.random() * 3)];
            let doneyset = false;
            for (const fitem of item.entry) {
                if (fitem.cellid !== xfield && fitem.cellid !== yfield && (colorid &&
                    fitem.cellid !== colorid)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === xfield) {
                    const sitem = sitemmap.get(fitem.cellid);
                    if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Text) {
                        let tmp = document.createElement("DIV");
                        tmp.innerHTML = value;
                        value = (_a = tmp.textContent) !== null && _a !== void 0 ? _a : '';
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                        const sitem = sitemmap.get(fitem.cellid);
                        value = (_c = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_b = sitem.excludedate) !== null && _b !== void 0 ? _b : false)) !== null && _c !== void 0 ? _c : '';
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                        const items = sitem.items.filter((it) => it.id === fitem.celldata);
                        if (items.length > 0) {
                            value = items[0].name;
                        }
                        else {
                            value = "";
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                        value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                    }
                    xdata.push(value);
                }
                else if (fitem.cellid === yfield) {
                    doneyset = true;
                    ydata.push({
                        val: value,
                        color: mycolor,
                        id: item.rowid
                    });
                }
                else if (fitem.cellid === colorid) {
                    mycolor = fitem.celldata;
                    if (doneyset) {
                        ydata[ydata.length - 1].color = mycolor;
                    }
                }
            }
        }
        cstate.setXDataset(xdata);
        cstate.setYDataset(ydata);
        cstate.setBuildingChart(false);
    }
    addChart(ctype) {
        const id = Math.random() + '';
        const cstate = new ChartViewState(id);
        cstate.setChartType(ctype);
        this.chartstate.set(id, cstate);
        return id;
    }
    reset() {
        this.loadedentry = 0;
        this.setUpdatingDatasheet(false);
        this.removingrowsfromsh.clear();
        this.hiddencolumns.clear();
        this.setActiveChildSchema("");
        this.setActiveAction("unknown");
        this.setAddingRowToChildren(false);
        this.resetNotes();
        this.setNotesLoading(false);
        this.setActiveTab('detail');
        this.setActiveRowId("");
        this.schemas.clear();
        this.setLoading(false);
        this.setActiveSchema("");
        this.setLoadingContent(false);
        this.setActiveView("grid");
        this.showganttenddatename = "Task End Date";
        this.showganttstartdatename = "Task Start Date";
        this.colorfieldname = "Default Colors";
        this.setShowGanttEndDate(false);
        this.setShowGanttStartDate(false);
        this.setGanttEndDate("");
        this.setGanttStartDate("");
        this.formentry.clear();
        this.newrowsmap.splice(0, this.newrowsmap.length);
        this.calendarstate.clear();
        this.kanbanstatus.clear();
        this.timelinestatus.clear();
        this.chartstate.clear();
        this.selectallrows = false;
        this.selectedrows.clear();
        this.getAnalytics(); // 
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "schemas", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "sortedschemaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "enableallsel", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "editrowslistitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "duplicating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "duplicatingcount", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "deleteentries", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activeschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadingcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showform", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "listitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "storingform", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "updatingdatasheet", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "parsingentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "formentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "rowsMap", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "newrowsmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "buildingview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showlinkdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "deleteingrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showactiveviewmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "copyactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showdtmennu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "copyschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "selectedrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showactions", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showstatuesmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "buildingrulefor", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "buildingruleforscol", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activecardsttaus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activecardgroupby", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "hiddenrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activecardstatusname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activecardgroupname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "startnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showgroupbymenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showganttstartdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showganttstartdatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showganttenddatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "colorfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "colorfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showcolorfield", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showchartmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showcolumnview", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminSchemaStore.prototype, "links", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "schemanotesloading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "checkingandcollecting", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "rowRules", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "storeschemaids", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "activeschemametaids", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "colwithschemarules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "gettinganas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "anas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "anasschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "deletenoteids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "shownotespanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "descfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "descfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showdescfield", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminSchemaStore.prototype, "activedetailtab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadingchats", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "deletingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "enableannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "readonlyrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showrowsilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "savingschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "notesbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminSchemaStore.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadingnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "authors", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showdervivedschemafields", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "hiddencolumns", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "showganttenddate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "ganttstartid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "ganttendid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "ganttasknameid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "ganttasknamefieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activerowid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "savingrow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "savingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "addingrowtochild", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "activechildschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "editrowproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "notelinksdialogleft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "notelinksdialogtop", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminSchemaStore.prototype, "chartstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "removingrowsfromsh", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "showpasswordfor", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminSchemaStore.prototype, "showinoutlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AdminSchemaStore.prototype, "activeaction", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "fetchingdepend", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "deletingschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminSchemaStore.prototype, "loadedentry", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadedRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "redoRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "parseCellRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeIdfromParsing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "decryptCell", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "clearAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "collectRowsAndBuildRulesResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setCollectingData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setGettingAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setGanttTaskField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setUpdatingDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addSchemaToRowChList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeSchemaFromRowChList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setGanttTaskFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setSavingRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveChildSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowDerviedSchemaFields", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setAuthor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowActions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDeleting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setEnableAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveAction", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "deleteLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addIdToRemovingCh", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeIdToRemovingCh", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setNoteLinksDialogLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setNoteLinksDialogTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setSelectedRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setUnSelectedRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "selectAllRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "unselectAllRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setAddingRowToChildren", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "clearShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowNotesPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setSavingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadingChat", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "clearLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setStartNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Array]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "updateRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowLinkDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setNotesLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDeleteingRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowChartMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowGanttStartDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowGanttEndDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowColorField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setColorFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setColorFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveRowId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removePropertiesFromActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setPropertiesForActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowDescField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDescFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDescFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeChartState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveGroupByMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowStatusesMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveCardStatusName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveCardGroupName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveCardStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveCardGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setBuildingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], AdminSchemaStore.prototype, "addRowInline", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], AdminSchemaStore.prototype, "addRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addRuleEntryToRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addRuleEntryToRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "removeNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setStoringForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadingContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoadmore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "resetNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "hideColumn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDuplicatingRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setDuplicatedCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "showColumn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowColumns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "cleaRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setFeatchingDepende", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setActiveSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "resetSchemaForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "setShowForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addFormEntry", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "addChart", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminSchemaStore.prototype, "reset", null);
